import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

let reconnectInterval = 2000; // 2 seconds
let isReconnecting = false;

@Injectable({
  providedIn: 'root',
})
export class FootPedalService {
  private socket: WebSocket;
  private footPedalEventSubject = new Subject<string>();

  constructor() {
    this.connectWebSocket();
  }

  private connectWebSocket(): void {
    this.socket = new WebSocket('ws://127.0.0.1:3000/media');

    this.socket.onopen = () => {
      console.log('WebSocket connection established');
      isReconnecting = false;
      this.socket.send('NSC');
    };

    this.socket.onmessage = (event) => {
      //console.log('Foot Pedal Event:', event.data);
      this.footPedalEventSubject.next(event.data); // Emit events to subscribers
    };

    this.socket.onerror = (error) => {
      console.error('WebSocket Error:', error);
    };

    this.socket.onclose = () => {
      console.log('WebSocket connection closed');
      if (!isReconnecting) {
        isReconnecting = true;
        setTimeout(() => {
          console.log('Attempting to reconnect...');
          this.connectWebSocket();
        }, reconnectInterval);
      }
    };
  }

  // Observable to subscribe to foot pedal events
  getFootPedalEvents(): Observable<string> {
    return this.footPedalEventSubject.asObservable();
  }
}
